const roundTo = (roundTo: number) => (date: number) =>
  Math.round(date / roundTo) * roundTo;
const roundDownTo = (roundTo: number) => (date: number) =>
  Math.floor(date / roundTo) * roundTo;
const roundUpTo = (roundTo: number) => (date: number) =>
  Math.ceil(date / roundTo) * roundTo;

export const roundTo5Minutes = roundTo(1000 * 60 * 5);
export const roundDownTo5Minutes = roundDownTo(1000 * 60 * 5);
export const roundDownTo10Minutes = roundDownTo(1000 * 60 * 10);
export const roundUpTo5Minutes = roundUpTo(1000 * 60 * 5);

export const roundDownToXMinutes = (date: number, minutes: number) => {
  return Math.floor(date / (minutes * 1000 * 60)) * (minutes * 1000 * 60);
};

export const getDaysFromHistory = (
  experienceActions: any[],
  endTs?: number
) => {
  // Sort actions by actionTs in ascending order
  const actions = [...experienceActions];
  actions.sort((a, b) => a.actionTs - b.actionTs);

  let totalLiveTime = 0;
  let liveStart: number | null = null; // Track when the item went live

  actions.forEach((action) => {
    if (action.action === "start") {
      if (liveStart === null) {
        // Start a new live session
        liveStart = action.actionTs;
      }
    } else if (action.action === "pause" || action.action === "end") {
      if (liveStart !== null) {
        // End the current live session
        totalLiveTime += action.actionTs - liveStart;
        liveStart = null; // Reset the live session
      }
    }
  });

  // If the last action was a start and there was no end or pause, calculate live time up to now
  if (liveStart !== null) {
    const currentTime = endTs ?? Date.now();
    totalLiveTime += currentTime - liveStart;
  }

  return totalLiveTime / (1000 * 60 * 60 * 24);
};
